import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, mergeMap, switchMap } from "rxjs/operators";
import { LicenseActions } from "../actions";
import { LicenseService } from "../services";

@Injectable()
export class LicenseEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly licenseService: LicenseService
  ) {}

  loadLicense$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LicenseActions.loadLicense),
      switchMap(() =>
        this.licenseService.loadLicense().pipe(
          mergeMap((_) => [LicenseActions.loadLicenseSuccess({ license: _ })]),
          catchError((_: Error) => [
            LicenseActions.loadLicenseFailure({
              error: _.message
            })
          ])
        )
      )
    )
  );
}
